import PropTypes from 'prop-types';
import React from 'react';
import {Keyboard, StyleSheet, TouchableOpacity, View} from 'react-native';
import {KeyboardAwareScrollView} from 'react-native-keyboard-aware-scroll-view';
import {Field} from 'redux-form';
import {Text} from 'trpc-react-native-ui';
import {HoshiInput, Icon, ValidationButton} from '../../components/common';
import {VoucherModal} from '../../components/voucherAddMoney';
import I18n from '../../lib/i18n';
import {formatValue} from '../../lib/usage-formatters';
import theme from '../../theme-config';

const getStyles = () =>
  StyleSheet.create({
    container: {},
    topSection: {
      padding: 15,
      marginHorizontal: 5,
      borderBottomColor: '#CACACA',
      borderBottomWidth: 1,
    },
    bottomSection: {
      alignItems: 'stretch',
      padding: 15,
    },
    inputsContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 20,
    },
    cameraButtonContainer: {
      marginVertical: 15,
    },
    cameraIcon: {
      color: '#CACACA',
    },
    fieldContainer: {
      marginTop: 15,
      alignSelf: 'center',
      width: 250,
      alignItems: 'stretch',
    },
    currentBalanceContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginVertical: 5,
    },
    label: {
      fontSize: 18,
      fontWeight: '600',
    },
    currentBalanceValue: {
      color: theme.primaryColor,
      fontSize: 22,
      fontWeight: '600',
    },
    description: {
      fontSize: 14,
      color: '#7D7D7D',
    },
    errorStyle: {
      maxWidth: 200,
      marginTop: 15,
      textAlign: 'center',
      alignSelf: 'center',
    },
  });

const AddMoney = props => {
  const styles = getStyles();

  return (
    <View style={styles.container}>
      <View style={styles.topSection}>
        <View style={styles.currentBalanceContainer}>
          <Text style={styles.label}>{I18n.t('currentBalance')}</Text>
          <Text style={styles.currentBalanceValue}>
            {formatValue(props.balance, 'MONETARY')}
          </Text>
        </View>
        <Text style={styles.description}>{I18n.t('voucherDescription')}</Text>
      </View>
      <KeyboardAwareScrollView
        extraHeight={250}
        keyboardShouldPersistTaps="always"
        enableOnAndroid="true">
        <View style={styles.bottomSection}>
          <View style={styles.inputsContainer}>
            <Text style={styles.label}>{I18n.t('voucherScannerTitle')}</Text>
            <View style={styles.cameraButtonContainer}>
              <TouchableOpacity
                onPress={() => props.navigation.navigate('voucherScanner')}>
                <Icon name="camera" size={75} style={styles.cameraIcon} />
              </TouchableOpacity>
            </View>
            <Text style={[styles.label, {marginVertical: 20}]}>
              {I18n.t('or')}
            </Text>
            <View style={styles.fieldContainer}>
              <Field
                name="voucherCode"
                type="digits"
                component={HoshiInput}
                placeholder={I18n.t('enterVoucher')}
                returnKeyType="go"
                errorStyle={styles.errorStyle}
                onSubmitEditing={() => Keyboard.dismiss()}
              />
            </View>
          </View>
          <ValidationButton
            text={I18n.t('validateVoucher')}
            onPress={() => {
              Keyboard && Keyboard.dismiss();
              props.handleSubmit();
            }}
            loading={props.isFetchingVoucher}
            disabled={!props.valid}
          />
          <VoucherModal loading={props.isRedeemingVoucher} />
        </View>
      </KeyboardAwareScrollView>
    </View>
  );
};

AddMoney.propTypes = {
  balance: PropTypes.number.isRequired,
  code: PropTypes.string,
  leaveAddMoneyScene: PropTypes.func,
  isFetchingVoucher: PropTypes.bool,
  isRedeemingVoucher: PropTypes.bool,
};

export default AddMoney;
